var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"boardRef",staticClass:"columns is-mobile is-flex is-gapless"},_vm._l((_vm.categories),function(cat){return _c('Category',{key:cat.title,attrs:{"title":cat.title}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }